/* eslint-disable semi */

'use strict';


/* globals google */
/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Uses google maps api to render a map
 */
var map;
var allStoresName = $('.store-name');

function maps() {
    var infowindow = new google.maps.InfoWindow();

    var grayStyles = [
        {
            elementType: 'geometry',
            stylers: [
                {
                    color: '#f5f5f5'
                }
            ]
        },
        {
            elementType: 'labels.icon',
            stylers: [
                {
                    visibility: 'off'
                }
            ]
        },
        {
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#616161'
                }
            ]
        },
        {
            elementType: 'labels.text.stroke',
            stylers: [
                {
                    color: '#f5f5f5'
                }
            ]
        },
        {
            featureType: 'administrative.land_parcel',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#bdbdbd'
                }
            ]
        },
        {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#eeeeee'
                }
            ]
        },
        {
            featureType: 'poi',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#757575'
                }
            ]
        },
        {
            featureType: 'poi.park',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#e5e5e5'
                }
            ]
        },
        {
            featureType: 'poi.park',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#9e9e9e'
                }
            ]
        },
        {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#ffffff'
                }
            ]
        },
        {
            featureType: 'road.arterial',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#757575'
                }
            ]
        },
        {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#dadada'
                }
            ]
        },
        {
            featureType: 'road.highway',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#616161'
                }
            ]
        },
        {
            featureType: 'road.local',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#9e9e9e'
                }
            ]
        },
        {
            featureType: 'transit.line',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#e5e5e5'
                }
            ]
        },
        {
            featureType: 'transit.station',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#eeeeee'
                }
            ]
        },
        {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#c9c9c9'
                }
            ]
        },
        {
            featureType: 'water',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#9e9e9e'
                }
            ]
        }
    ];

    // Init Portugal Map in the center of the viewport
    var latlng = new google.maps.LatLng(39.399872, -8.224454);
    var mapOptions = {
        scrollwheel: false,
        zoom: 5,
        center: latlng,
        styles: grayStyles,
        zoomControl: true,
        zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_TOP
        },
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        gestureHandling: 'greedy'
    };


    map = new google.maps.Map($('.map-canvas')[0], mapOptions);
    var mapdiv = $('.map-canvas').attr('data-locations');

    mapdiv = JSON.parse(mapdiv);

    var bounds = new google.maps.LatLngBounds();

    // Customized google map marker icon with svg format
    var markerImg = {
        url: window.ImageResource,
        fillOpacity: 1,
        scale: 1,
        strokeWeight: 0,
        scaledSize: new google.maps.Size(40, 40)
    };

    Object.keys(mapdiv).forEach(function (key) {
        var item = mapdiv[key];
        var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
        var marker = new google.maps.Marker({
            position: storeLocation,
            map: map,
            title: item.name,
            targetZoom: 22,
            icon: markerImg,
            anchor: new google.maps.Point(40, 40)
        });

        // the smooth zoom function
        function animateMapZoomTo(targetZoom, commandedZoom) {
            var currentZoom = commandedZoom || map.getZoom();
            if (currentZoom != targetZoom) {
                google.maps.event.addListenerOnce(map, 'zoom_changed', function () {
                    animateMapZoomTo(map, targetZoom, currentZoom + (targetZoom > currentZoom ? 1 : -1));
                });
                setTimeout(function () {
                    map.setZoom(currentZoom + (targetZoom > currentZoom ? 1 : -1))
                }, 500);
            }
        }

        // Open marker informations
        marker.addListener('click', function () {
            infowindow.setOptions({
                content: item.infoWindowHtml
            });
            infowindow.open(map, marker);
            map.panTo(this.getPosition());
            var newZoom = map.getZoom() + 2;
            if (map.getZoom() <= 5) {
                animateMapZoomTo(map, 10);
            } else {
                animateMapZoomTo(map, newZoom);
            }
        });

        // close marker informations
        map.addListener('click', function () {
            infowindow.setOptions({
                content: item.infoWindowHtml
            });
            infowindow.close(map, marker);
        });

        // Create a minimum bound based on a set of storeLocations
        bounds.extend(marker.position);

        allStoresName.each(function () {
            var storeId = ('#' + $(this).attr('id'));

            if (marker.title == this.textContent) {
                $('body').on('click', storeId, function () {
                    infowindow.setOptions({
                        content: item.infoWindowHtml
                    });
                    infowindow.open(map, marker);
                    map.panTo(marker.getPosition());
                    if (map.getZoom() <= 5) {
                        animateMapZoomTo(map, 10);
                    }
                });
            }
        });
    });

    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    if (mapdiv && mapdiv.length > 0) {
        map.fitBounds(bounds);
    }

    var listener = google.maps.event.addListener(map, 'idle', function () {
        if (map.getZoom() > 16) {
            map.setZoom(15);
        }
        google.maps.event.removeListener(listener);
    });
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
    var $resultsDiv = $('.results');
    var $mapDiv = $('.map-canvas');
    var hasResults = data.stores.length > 0;

    if (!hasResults) {
        $('.store-locator-no-results').show();

        // checkout pickup-in-store
        $('.select-store').attr('disabled', true);
        $('.pickup-in-store .store-locator-results').hide();

        // PDP - availability in store
        $('.store-locator-avaiable-stores').hide();
        $('#availability-state-container .store-locator-no-results').show();
    } else if (data.radius == 10000) {
        $('.store-locator-no-results').show();

        // checkout pickup-in-store
        $('.select-store').attr('disabled', true);
        $('.pickup-in-store .store-locator-results').hide();

        // PDP - availability in store
        $('.store-locator-avaiable-stores').show();
        $('#availability-state-container .store-locator-no-results').hide();
    } else {
        $('.store-locator-no-results').hide();

        // PDP - availability in store
        $('.store-locator-avaiable-stores').show();
        $('#availability-state-container .store-locator-no-results').hide();
    }

    $resultsDiv.empty()
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data('search-key', data.searchKey);

    $mapDiv.attr('data-locations', data.locations);

    if ($mapDiv.data('has-google-api')) {
        maps();
    } else {
        $('.store-locator-no-apiKey').show();
    }

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
    }
}
/**
 * Validation for zip code
 * @param {*} value
 * @param {*} pattern
 */
function validateZipCode(value, pattern) {
    var reg = new RegExp(pattern);
    if (!reg.test(value)) {
        $('#store-postal-code').addClass('is-invalid');
        $('#store-postal-code').siblings('.invalid-feedback').empty();
        $('#store-postal-code').siblings('.invalid-feedback').append(window.wrongFormat);
    } else {
        $('#store-postal-code').removeClass('is-invalid');
        $('#store-postal-code').siblings('.invalid-feedback').empty();
    }
}

$('#store-postal-code').on('change', function () {
    validateZipCode($(this).val(), $(this).attr('pattern'));
});

/**
 *
 * @param {*} radius
 */
function updateRadius(radius) {
    radius = 10000;

    var url = $('.store-locator-container .district-select').data('action-url');
    var urlParams = {};

    urlParams = {
        radius: radius
    };

    url = appendToUrl(url, urlParams);
    var dialog = $(this).closest('.in-store-inventory-dialog');
    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            spinner.stop();
            $('.select-store').prop('disabled', true);
            updateStoresResults(data);
        }
    });
}

function availabilityState() {
    require('improove/util/states').add('availability', $('.state-container--availability'), $('.availability-state-trigger'), {});
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search(element, radius = 75) {
    var dialog = element.closest('.in-store-inventory-dialog');
    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();
    var $form = element.closest('.store-locator');

    var payload = $form.is('form') ? $form.serialize() : { postalCode: $form.find('[name="postalCode"]').val() };

    var storeLocatorPostalCode = $('#store-postal-code').val();

    if (!storeLocatorPostalCode) {
        radius = 10000;
    }

    var url = $form.attr('action');
    var urlParams = { radius: radius };

    url = appendToUrl(url, urlParams);

    $.ajax({
        url: url,
        type: $form.attr('method'),
        data: payload,
        dataType: 'json',
        success: function (data) {
            spinner.stop();

            var storeResults = $('#store-locator-results .card-body');
            var isCheckout = $('.checkout-pickup-instore');

            // quick fix to prevent storelocator code running inside checkout
            if (isCheckout.length == 0) {
                updateStoresResults(data, element);
                if (storeResults.length > 0 && storeResults.length < 2) {
                    radius += 25;
                    search(element, radius);
                } else if (storeResults.length == 0) {
                    updateRadius(radius);
                }
            }
        }
    });
    return false;
}

/**
 * This Function check what is the selected shippingMethod in checkout
 */
function getSelectedShippingMethod() {
    let allShippingMethods = document.querySelectorAll('[id*="shippingMethod"]');
    if (allShippingMethods) {
        for (let i = 0; i < allShippingMethods.length; i++) {
            let selectedShip = allShippingMethods[i];
            if (selectedShip.checked == true) {
                return selectedShip.defaultValue;
            }
        }
    }
    return false;
}

/**
 *
 * @param {*} radius
 * @param {*} districtPostalCode
 */
function updateDistrict(radius, districtPostalCode) {
    var url = $('.store-locator-container .district-select').data('action-url');
    var urlParams = {};

    urlParams = {
        radius: radius,
        postalCode: districtPostalCode
    };

    url = appendToUrl(url, urlParams);
    var dialog = $(this).closest('.in-store-inventory-dialog');
    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            spinner.stop();
            $('.select-store').prop('disabled', true);
            updateStoresResults(data);
            var storeResultsDistrict = $('#store-locator-results .card-body');
            if (storeResultsDistrict.length > 0 && storeResultsDistrict.length < 2) {
                radius += 25;
                updateDistrict(radius, districtPostalCode);
            } else if (storeResultsDistrict.length == 0) {
                updateRadius(radius);
            }
        }
    });
}

// clean search when click on select
$('.store-locator-container .district-select').on('click', function () {
    $('#store-postal-code').val('');
    $('.form-control-label').removeClass('focused');
});

// clean select when click on search
$('#store-postal-code').on('click', function () {
    $('.store-locator-container .district-select').val('1');
});


// stuff to animate label in input fields
$('body').on('focusin', '.form-control', function () {
    $(this).siblings('.form-control-label').addClass('focused');
    $(this).removeClass('is-invalid');
    $(this).siblings('.invalid-feedback').empty();
});

$('body').on('focusout', '.form-control', function () {
    if ($(this).val() === '') {
        $(this).siblings('.form-control-label').removeClass('focused');
    }
});

$('body').on('focusin', '.form-control', function () {
    $(this).siblings('.form-control-label').addClass('focused');
    $(this).removeClass('is-invalid');
    $(this).siblings('.invalid-feedback').empty();
});

// this was commented because it didn't let check any checkbox

/* $('label').click(function () {
    var labelID = $(this).attr('for');
    $('#' + labelID).trigger('click');
}); */

$('.form-control').each(function () {
    if ($(this).val() != '') {
        $(this).siblings('.form-control-label').addClass('focused');
    }
});

$(".store-details a").prop("target", "_blank");

// increase margin-top when scrolling
$(window).scroll(function () {
    if ($(window).width() > 1024) {
        var scroll = $(window).scrollTop();

        if (scroll >= 100) {
            $('.map-canvas').animate({
                margin: '13rem 0 0 0'
            }, {
                queue: false, duration: 30
            });
        } else {
            $('.map-canvas').animate({
                margin: '6rem 0 0 0'
            }, {
                queue: false, duration: 300
            });
        }
    }
});

module.exports = {
    init: function () {
        if ($('.map-canvas').data('has-google-api')) {
            maps();
        } else {
            $('.store-locator-no-apiKey').show();
        }

        if (!$('.results').data('has-results')) {
            $('.store-locator-no-results').show();
        }
    },

    detectLocation: function () {
        // clicking on detect location.
        $('.detect-location').on('click', function () {
            $.spinner().start();
            if (!navigator.geolocation) {
                $.spinner().stop();
                return;
            }

            navigator.geolocation.getCurrentPosition(function (position) {
                var $detectLocationButton = $('.detect-location');
                var url = $detectLocationButton.data('action');
                var radius = $('.results').data('radius');
                var urlParams = {
                    radius: radius,
                    lat: position.coords.latitude,
                    long: position.coords.longitude
                };

                url = appendToUrl(url, urlParams);
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $.spinner().stop();
                        updateStoresResults(data);
                        $('.select-store').prop('disabled', true);
                    }
                });
            });
        });
    },

    search: function (forceSearch) {
        $('.store-locator-container form.store-locator').submit(function (e) {
            e.preventDefault();
            search($(this));
        });
        $('.store-locator-container .btn-storelocator-search[type="button"]').click(function (e) {
            e.preventDefault();
            search($(this));
        });
        if (forceSearch) {
            search($('.store-locator'));
        }
    },

    changeDistrict: function () {
        $('.store-locator-container .district-select').change(function () {
            var district = $(this).find('option:selected').attr('name');
            var districtPostalCode = $(this).val();
            var url = $(this).data('action-url');
            var urlParams = {};
            var radius = 75;

            allStoresName.each(function searchDistrict() {
                if (district == this.textContent) {
                    urlParams = {
                        radius: radius,
                        postalCode: districtPostalCode
                    };
                    return false;
                }
                urlParams = {
                    radius: radius,
                    postalCode: districtPostalCode
                };
            });

            url = appendToUrl(url, urlParams);
            var dialog = $(this).closest('.in-store-inventory-dialog');
            var spinner = dialog.length ? dialog.spinner() : $.spinner();
            spinner.start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    spinner.stop();
                    $('.select-store').prop('disabled', true);
                    updateStoresResults(data);
                    var storeResultsDistrict = $('#store-locator-results .card-body');
                    if (storeResultsDistrict.length < 2) {
                        radius += 25;
                        updateDistrict(radius, districtPostalCode);
                    } else if (storeResultsDistrict.length == 0) {
                        updateRadius(radius);
                    }
                }
            });
        });
    },

    updateFieldIpnut: function () {
        $('body').on('click', '.postalCodeSelector', function () {
            $('.district-select').val('1');
        });
    },

    updateFieldDropDows: function () {
        $('body').on('click', '.district-select', function () {
            $('.postalCodeSelector').val('');
        });
    },

    updateAvailabilityContent: function () {
        $('body').on('product:afterAttributeSelectAvailable', function () {
            var baseURL = $('.product-id').data('action-url') + '?showMap=true&products=' + $('.product-id')[0].innerText + ':1';
            $('.availability-state-trigger').data('action-url', baseURL);
            var url = baseURL;
            $('.postalCodeSelector').data('actionUrl', baseURL);
            $('.district-select').data('actionUrl', baseURL);

            if ($('.postalCodeSelector').val() != 0) {
                var zipCodeD = $('.postalCodeSelector').val();
                var newURL = url + '&radius=50&postalCode=' + zipCodeD;
                url = newURL;
            }

            if ($('.district-select').val() != '1') {
                var zipCodeI = $('.district-select').val();
                var newURI = url + '&radius=50&postalCode=' + zipCodeI;
                url = newURI;
            }

            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    $('.select-store').prop('disabled', true);
                    updateStoresResults(data);
                }
            });
        });
    },

    autoSearchStores: function () {
        $('body').on('keyup', '.postalCodeSelector', require('lodash/debounce') (function () {
            var district = $(this).val();
            var url = $(this).data('action-url');
            var urlParams = {};
            var radius = 75;
            urlParams.radius = radius;
            urlParams.postalCode = district;

            allStoresName.each(function searchDistrict() {
                if (district == this.textContent) {
                    urlParams.radius = radius;
                    urlParams.postalCode = district;
                    return false;
                }
                urlParams.radius = radius;
                urlParams.postalCode = district;
            });

            url = appendToUrl(url, urlParams);
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    $('.select-store').prop('disabled', true);
                    updateStoresResults(data);
                }
            });
        }, 1000));
    },

    changeDistrictPDP: function () {
        $('body').on('change', '[data-district-selector]', function () {
            var district = $(this).find('option:selected').attr('name');
            var districtPostalCode = $(this).val();
            var url = $(this).data('action-url');
            var urlParams = {};
            var radius = 75;
            urlParams.radius = radius;
            urlParams.postalCode = districtPostalCode;

            // Code added by Improove, Verify wich shippingMethod is selected and add it to URL.
            // let url = target.data('url');
            let selectedShip = getSelectedShippingMethod();
            if (selectedShip != false) {
                urlParams.selectedShip = selectedShip;
            }
            // Code added by Improove, End.

            allStoresName.each(function searchDistrict() {
                if (district == this.textContent) {
                    urlParams.radius = radius;
                    urlParams.postalCode = districtPostalCode;
                    return false;
                }
                urlParams.radius = radius;
                urlParams.postalCode = districtPostalCode;
            });

            url = appendToUrl(url, urlParams);
            var dialog = $(this).closest('.in-store-inventory-dialog');
            var spinner = dialog.length ? dialog.spinner() : $.spinner();
            spinner.start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    spinner.stop();
                    $('.select-store').prop('disabled', true);
                    updateStoresResults(data);
                }
            });
        });
    },

    openAvailabilityState: function () {
        $('.availability-state-trigger').on('click', function () {
            var url = $(this).data('action-url');
            var productID = document.querySelector('[class="product-id"]');
            if (productID) {
                document.cookie = 'pidPdp=' + productID.innerText + ';path=/';
            }
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    $('.select-store').prop('disabled', true);
                    updateStoresResults(data);
                }
            });
            availabilityState();
            $('.background_black_overlay-pdp').removeClass('d-none');
            $('.state-container--availability').removeClass('d-none');
            $('body').addClass('state-container--availability-fixer');
        });
    },

    selectStore: function () {
        $('.store-locator-container').on('click', '.select-store', (function (e) {
            e.preventDefault();
            var selectedStore = $(':checked', '.results-card .results');
            var data = {
                storeID: selectedStore.val(),
                searchRadius: $('#radius').val(),
                searchPostalCode: $('.results').data('search-key').postalCode,
                storeDetailsHtml: selectedStore.siblings('label').find('.store-details').html(),
                event: e
            };

            $('body').trigger('store:selected', data);
        }));
    },
    updateSelectStoreButton: function () {
        $('body').on('change', '.select-store-input', (function () {
            $('.select-store').prop('disabled', false);
        }));
    },

    //  function to show/hide content in mobile storeLocator
    selectView: function () {
        $('.store-locator-buttons button').on('click', function () {
            const myLatlng = { lat: 39.399872, lng: -8.224454 };
            map.setZoom(4.5); // set the zoom of the map.
            map.setCenter(myLatlng);
            var contentBlock = $('#locator-block'),
                btnShow = $('.store-locator-buttons button');
            btnShow.removeClass('active');
            contentBlock.find('div[data-id="' + $(this).siblings().attr('id') + '"]').hide();
            contentBlock.find('div[data-id="' + $(this).attr('id') + '"]').show();
            $(this).addClass('active');
        });
    }
};

//Add target blank on Saber Mais on select your store
window.onload = function(){
    var timeBlanck = setTimeout(function(){
        $(".store-hours a").prop("target", "_blank");closeTimeBlank();
        $('#btn-map').on( "click", function() {
            $(".store-hours a").prop("target", "_blank");
          });
    },3000);
    function closeTimeBlank() {
        clearTimeout(timeBlanck);
    }

}
